<template>
		<div class="p-4">
			<Steps :currentStep="2"></Steps>
		</div>
    <Resume/>
</template>

<script>

import Steps from '../../Widgets/Promotions/NewPromotion/Steps/Steps.vue';
import Resume from '../../Widgets/Promotions/NewPromotion/Resume/Resume.vue';
export default {
  name: 'NewPromotionStep2',
  components: {
    Steps,
    Resume
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>